import styled from 'styled-components';

export default styled.hr`
  border: 0;
  margin: 0;
  padding: 12.5px 0;
`;
